import * as React from 'react';
import * as styles from './AppPromotionQuoteCard.scss';

interface IAppExclusiveCardItemProps {
  imageSrc?: string;
  name: string;
  comment: string;
}

class AppPromotionQuoteCard extends React.Component<IAppExclusiveCardItemProps, {}> {

  public render() {
    const { comment, imageSrc, name } = this.props;

    return (
      <span className={styles.quoteContainer}>
        <span className={styles.RatingInfo}>
          <img src={imageSrc} alt='Bewertung' className={styles.CardStars} />
          <div className={styles.CardName}>{name}</div>
        </span>
        <div className={styles.CardComment}>{comment}</div>
      </span>
    );
  }

}

export default AppPromotionQuoteCard;
